import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { PaymentUrlResponse, Subscription } from '../../models/payment.interface';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  apiAddress: string = environment.apiAddress;

  constructor(private http: HttpClient) {}

  getPaymentUrl(): Observable<PaymentUrlResponse> {
    return this.http.get<PaymentUrlResponse>(`${this.apiAddress}/subscription/payment/url`);
  }
  getLastSubscription(): Observable<Subscription> {
    return this.http.get<Subscription>(`${this.apiAddress}/subscription/check/last`);
  }
}
